import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import HelpTooltip from 'components/ui/HelpTooltip';
import { BaseTabButton } from 'components/ui/button/TabButton';

import commonPropTypes from 'utils/commonPropTypes';

import * as svars from 'assets/style/variables';

// Create a styled component that applies the color transition
const AnimatedButton = styled(BaseTabButton)`
  ${({ animate }) =>
    animate &&
    css`
      &&& {
        background-color: ${svars.colorSuccessLighter};
        transition: background-color 0.3s ease-in-out;
      }
    `}
`;

function DeletableLabel({
  onClick,
  disabled,
  content,
  style,
  animate,
  ...props
}) {
  return (
    <HelpTooltip
      mouseEnterDelay={900}
      help={[content]}
      on="hover"
      compact
      size="tiny"
      position="top center"
      baseColor
      trigger={
        <span>
          <AnimatedButton
            {...props}
            content={content}
            disabled={disabled}
            labelPosition="right"
            icon="delete"
            style={{ marginRight: svars.spaceNormal, ...style }}
            onClick={onClick}
            animate={animate ? 1 : 0}
          />
        </span>
      }
    />
  );
}

DeletableLabel.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  style: commonPropTypes.style,
  animate: PropTypes.bool,
};

DeletableLabel.defaultProps = { style: {}, animate: false, disabled: false };

export default DeletableLabel;
